<template>
  <v-dialog v-model="dialog" max-width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon small v-bind="attrs" v-on="on" class="ml-2">
        <v-icon>mdi-history</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title style="background-color: #2b3990">
        <span class="headline white--text">Prescriber History</span>
      </v-card-title>

      <v-card-text class="pt-4">
        <div v-if="history && history.length > 0">
          <div v-for="(item, index) in history" :key="index" class="mb-4">
            <div class="subtitle-1">Prescriber: {{ item.prescriberName }}</div>
            <div class="caption">
              Changed by: {{ item.changedByName }}
              <br />
              Date: {{ formatDate(item.changedAt) }}
            </div>
            <v-divider
              v-if="index !== history.length - 1"
              class="my-2"
            ></v-divider>
          </div>
        </div>
        <div v-else class="text-center pa-4">
          No prescriber history available
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PrescriberHistoryDialog",
  props: {
    history: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleString();
    },
  },
};
</script>
